import { render, staticRenderFns } from "./FrecuenciaList.vue?vue&type=template&id=a1ecda1c"
import script from "./FrecuenciaList.vue?vue&type=script&setup=true&lang=js"
export * from "./FrecuenciaList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports